<template>
    <div class="borrow">
        <div class="search">
            <Input v-model="search" :placeholder="$t('searchTips')+'...'" style="width:200px;"></Input>
            <DatePicker type="date" v-model="start" placeholder="选择开始日期" style="width: 200px" />
            <DatePicker type="date" v-model="end" placeholder="选择结束日期" style="width: 200px" />
            <Button type="primary" @click="loadData(currentPage)">搜索</Button>
        </div>
        <Table border :columns="columns12" :data="data6" style="width: 100%;">
            <template slot-scope="{ row }" slot="name">
                <strong>{{ row.name }}</strong>
            </template>
        </Table>
        <div class="page">
            <Page
                :total="totalItems"
                :page-size="itemsPerPage"
                show-elevator
                :current="currentPage"
                @on-change="loadData"
            />
        </div>
          
        <!-- <Modal v-model="jt_img" :title="$t('borrow.insuranceImg')">
            <div class="jt_img">
                <img :src="$ht_ip+''" alt />
            </div>
        </Modal> -->
        <Modal
            v-model="showDelModal"
            :title="$t('del')"
            @on-ok="delRow(modalItem)"
            @on-cancel="showDelModal=false"
        >
            <p>{{$t('confirmDel')}}</p>
        </Modal>
        
    </div>
</template>
<script>
import { formatUTCTime as formatUTC } from '../../common/common.js';
export default {
    data() {
        return {
            modalItem: {},
            showDelModal: false,
            userIdToDel: 0,
            currentPage: 1,
            totalPages: 1,
            itemsPerPage: 10,
            totalItems: 0,
            search: "",
            start:'',
            end:'',
            totalItems: 1,
            edit_money: false,
            edit_money2: false,
            change_sts: false,
            withdrawEnabled:false,
            withdrawReject:false,
            showBankNumModal: false,
            jt_img: false,
            money_modal: {},
            status_data: [],
            columns12: [
                {
                    title: "ID",
                    width: 60,
                    key: "id",
                },
                {
                    title: "Email",
                    width: 150,
                    key: "member_email",
                },
                {
                    title: this.$i18n.t('mobile'),
                    width: 120,
                    key: "member_mobile",
                },

                {
                    title: this.$i18n.t('userView.cname'),
                    width: 80,
                    key: "member_username",
                },
                {
                    title: this.$i18n.t('borrow.orderNumber'),
                    width: 130,
                    key: "order_num"
                },
                {
                    title: this.$i18n.t('exchange'),
                    width: 100,
                    key: "money",
                    render: (h, params) => {
                        return h("span", {style:{color: 'red'}}, "-" + params.row.money)
                    }
                },
                {
                    title: this.$i18n.t('rate'),
                    width: 110,
                    key: "rate"
                },
                {
                    title: this.$i18n.t('rate_money'),
                    width: 150,
                    key: "rate_money,member.rate",
                    render: (h, params) => {
                        return h("div",{style:params.row.is_hot==1 ? {backgroundColor: 'yellow',padding: ' 10px 5px'} : ''}, [
                            h("span", {style:{color: 'green'}},"+" + params.row.rate_money,),
                            h("span", {style:{color: 'red'}},`(${params.row.is_hot==1 ? 9 : params.row.member_rate}%)`)
                        ]);
                    }
                },
                {
                    title: this.$i18n.t('time'),
                    width: 150,
                    key: "created_at",
                    render: (h, params) => {
                        return h("div", [
                            h("div", formatUTC(params.row.created_at, 8))
                        ]);
                    }
                },
                {
                    title: this.$i18n.t('status'),
                    width: 110,
                    key: "status",
                    render: (h, params) => {
                        if (params.row.status == 0) {
                            return h("div", [
                                h("Select", {
                                    props: {
                                        value: params.row.status,
                                        style: {width: '100%'}
                                    },
                                    on: {
                                        'on-change': (value) => {
                                            this.edit_status(params.row, value)
                                        }
                                    }
                                }, [
                                    h("Option", {
                                        props: {
                                            value: 1
                                        }
                                    }, this.$i18n.t('pass')),
                                    h("Option", {
                                        props: {
                                            value: 2
                                        }
                                    }, this.$i18n.t('reject'))
                                ])
                            ])
                        } else {
                            return h("span", {
                                style: {
                                    color: params.row.status == 1 ? 'green' : 'red'
                                }
                            }, params.row.status == 1 ? this.$i18n.t('pass') : this.$i18n.t('reject'))
                        }
                    }
                },
                {
                    title:this.$i18n.t('note'),
                    width: 150,
                    key: "remark",
                    render: (h, params) => {
                        if (params.row.status == 2) {
                            return h("div", [
                                h("Input", {
                                    props: {
                                        value: params.row.remark || '',
                                        style: {width: '100%'}
                                    },
                                    on: {
                                        'on-blur': (event) => {
                                            this.edit_remark(params.row, event.target.value)
                                        }
                                    }
                                })
                            ])
                        } else {
                            return h("span", params.row.remark || '-')
                        }
                    }
                },
                {
                    title:this.$i18n.t('action'),
                    width: 110,
                    key: "action",
                    render: (h, params) => {
                        return h("div",{style:{display: 'flex', flexDirection: 'row', justifyContent: 'space-between',gap: '5px'}}, [
                            h("Icon", {
                                props: {
                                    type: 'md-trash',
                                    size: 24,
                                    color: 'white'
                                },
                                style: {
                                    backgroundColor: 'red',
                                    border: 'none',
                                },
                                on: {
                                    click: () => {
                                        this.delRow(params.row.id)
                                    }
                                }
                            }),
                        ]);
                    }
                }
            ],
            data6: []
        };
    },
    mounted() {
        this.loadData(1);
    },
    methods: {
        loadData(page) {
            this.currentPage = page;
            this.$get(this.$path.order, {
                page: this.currentPage,
                search: this.search,
                start: this.start,
                end: this.end
            }).then(res => {
                if (res.data) {
                    this.data6 = res.data.list;
                    this.totalItems = res.data.pageObj.totalSize;
                    this.itemsPerPage = res.data.pageObj.pageSize;
                } else {
                    this.$Message.error(this.$i18n.t('dataFailed'));
                }
            });
        },
        showUserDetail(user_id) {
            this.$router.push({
                name: "user_detail",
                query: {
                    user_id: user_id
                }
            });
        },
        // editMoney(row) {
        //     this.modalItem = row;
        //     this.edit_money = true;
        // },
        // edit_money_ok() {
        //     this.$post(this.$path.borrow_edit_money, {
        //         order_id: this.modalItem.order_id,
        //         money: this.modalItem.money,
        //         month:this.modalItem.month
        //     }).then(res => {
        //         if (res.success) {
        //             this.$Message.success(this.$i18n.t('operateSuccess'));
        //             this.loadData(this.currentPage);
        //         } else {
        //             this.$Message.error(this.$i18n.t('operateFailed'));
        //         }
        //     });
        // },
        delRow(id) {
            this.$post(this.$path.order_del, {
                id: id
            }).then(res => {
                if (res.success) {
                    this.$Message.success(this.$i18n.t('operateSuccess'));
                    this.loadData(this.currentPage);
                } else {
                    this.$Message.error(this.$i18n.t('operateFailed'));
                }
            });
        },
        delModal(row) {
            this.modalItem = row;
            this.showDelModal = true;
        },
        change_status(row) {
            this.modalItem = row;
            this.change_sts = true;
            this.$get(this.$path.change_status).then(res => {
                if (res.success) {
                    this.status_data = res.data;
                }
            });
        },
       
        
        edit_status(row,status) {
            this.$post(this.$path.change_status, {
                order_id: row.id,
                status: status,
                user_id: row.user_id,
            }).then(res => {
                if (res.success) {
                    this.$Message.success(this.$i18n.t('operateSuccess'));
                    this.loadData(this.currentPage);
                }
            });
        },
        
       
        
        
        edit_remark(row, remark) {
            this.$post(this.$path.order_edit, {
                order_id: row.id,
                remark: remark,
            }).then(res => {
                if (res.success) {
                    this.$Message.success(this.$i18n.t('operateSuccess'));
                    this.loadData(this.currentPage);
                } else {
                    this.$Message.error(this.$i18n.t('operateFailed'));
                }
            });
        }
    }
};
</script>
<style lang="scss" scoped>
.search {
    margin-bottom: 20px;
}
.page {
    margin-top: 20px;
    display: flex;
    justify-content: center;
}
.jt_img {
    width: 100%;
    img {
        width: 100%;
    }
}
.order_num {
    display: flex;
    flex-direction: row;
    .tit {
        width: 60px;
        color: #bab9b9;
    }
    .info {
        width: 200px;
    }
}
.sts_list {
    margin-top: 10px;
    .tit {
        width: 100px;
        color: #bab9b9;
    }
}
.op_btn {
    margin-top: 5px;
}
.op_btn:nth-child(2) {
    margin-bottom: 5px;
}
/*.radio_div {
     width: 25%; 
}*/
.ivu-radio-group {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
}
.red_color{
    color: red;
}
</style>


// WEBPACK FOOTER //
// src/components/user/order.vue